<template>
  <div>
    <child-development-progress-container />
  </div>
</template>
<script lang="ts">
import { defineComponent } from "vue";

import ChildDevelopmentProgressContainer from "@/containers/child-development/ChildDevelopmentProgressContainer.vue";

export default defineComponent({
  components: {
    ChildDevelopmentProgressContainer,
  },
});
</script>
